import { render, staticRenderFns } from "./AssessmentsMain.vue?vue&type=template&id=478d008c&scoped=true"
import script from "./AssessmentsMain.vue?vue&type=script&lang=js"
export * from "./AssessmentsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478d008c",
  null
  
)

export default component.exports